module.exports = __webpack_public_path__ + "img/gl.c1b5bc95.png";